<template>
  <v-dialog width="700" v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" :disabled="!canCancel" v-bind="attrs" v-on="on">
        <v-icon left dark>mdi-close</v-icon>
        {{ $t("integrations.order.form.actions.cancel_order") }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ $t("integrations.order.cancel.confirmation_title") }}</v-card-title>
      <v-card-text>
        {{ $t("integrations.order.form.actions.cancel_description", { orderId: item.id }) }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" :disabled="canceling" @click="closeDialog">
          <v-icon left>mdi-close-circle</v-icon>
          {{ $t("va.actions.abort") }}
        </v-btn>
        <v-btn color="primary" :loading="canceling" @click="cancelOrder">
          <v-icon left>mdi-close</v-icon>
          {{ $t("integrations.order.form.actions.cancel_order") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from "@skuhnow/vuetify-admin/src/mixins/button";

export default {
  mixins: [Button],
  data() {
    return {
      dialog: false,
      canceling: false
    };
  },
  computed: {
    canCancel() {
      const cancelableStates = ["new", "validated", "pending_payment", "confirmed_payment", "processing", "finished", "problematic"];
      return cancelableStates.includes(this.item.state);
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    cancelOrder() {
      this.canceling = true;
      this.$admin.http
        .patch(`/orders/${this.item.id}`, { state: "cancel" })
        .then(() => {
          this.$store.commit(`messages/showToast`, {
            color: "success",
            message: `Order "${this.item.id}" was canceled.`
          });
          this.$emit("orderCanceled");
          this.closeDialog();
        })
        .catch(() =>
          this.$store.commit(`messages/showToast`, {
            color: "error",
            message: `Error while canceling order "${this.item.id}"`
          })
        )
        .finally(() => {
          this.canceling = false;
          this.$store.dispatch("api/refresh", this.$route.meta.resource);
        });
    }
  }
};
</script>
